import React, { useReducer } from 'react';
import clienteAxios from '../../service/axios';
import VariableContext from './variableContext';
import VariableReducer from './variableReducer';

import {
    OBTENER_VARIABLES,
    AGREGAR_VARIABLE,
    ELIMINAR_VARIABLE,
    ACTUALIZAR_VARIABLE,
    VARIABLE_ERROR,
    VARIABLE_OK,
    VARIABLE_ACTUAL,
    OBTENER_VARIABLE,
    OBTENER_VARIABLE_TABLA
} from 'types/context';

const VariableState = props => {
    const initialState = {
        variables: [], // variables del dipositivo
        variable: null,
        dipositivo: null,
        loading: true,
        errorformulario: false,
        mensaje: null
    }

    const [state, dispatch] = useReducer(VariableReducer, initialState);
    //obtener variables para pantalla alerta
    const obtenerVariablesTabla = async (cliente, rol) => {
        try {
            // siempre deberia venir un dipositivo
            let resultado;
            resultado = await clienteAxios.get(`/tablaAlertas/variablesSupervisadas/${cliente}`);
            //
            dispatch({
                type: OBTENER_VARIABLE_TABLA,
                payload: resultado.data.variablesPopuladas
            });
            //
            return {
                data: resultado.data.variablesPopuladas
            }
        } catch (error) {
            //
            const alerta = {
                msg: error,
                categoria: 'error'
            }
            dispatch({
                type: VARIABLE_ERROR,
                payload: alerta
            })
        }
    }

    // Obtener los Variables
    const obtenerVariables = async (param) => {
        if (param) {
            const { dispositivoId, rol, id } = param;
            let query = "?";

            if (dispositivoId) {
                const filter = query !== "?" ? "&" : "";
                query = query + filter + "dispositivoId=" + dispositivoId;
            }
            if (id) {
                const filter = query !== "?" ? "&" : "";
                query = query + filter + "id=" + id;
            }
            try {
                // siempre deberia venir un dipositivo
                let resultado = await clienteAxios.get(`variable-dispositivos${query !== "?" ? query : ""}`);

                dispatch({
                    type: OBTENER_VARIABLES,
                    payload: resultado?.data?.variableDispositivos?.rows || []
                });
                //
                return {
                    data: resultado?.data?.variableDispositivos?.rows || [],
                    page: resultado.data.pagina - 1,
                    totalCount: resultado.data.totalRegistros
                }
            } catch (error) {
                //
                const alerta = {
                    msg: error,
                    categoria: 'error'
                }
                dispatch({
                    type: VARIABLE_ERROR,
                    payload: alerta
                })
            }
        }          
    }
    // Agregar nuevo variable
    const agregarVariable = async variable => {
        try {
            const resultado = await clienteAxios.post('/variable-dispositivos', variable);
            //
            // Insertar el variable en el estado
            dispatch({
                type: AGREGAR_VARIABLE,
                payload: resultado.data.variable
            })
            const alerta = {
                msg: "Operacion realizada con exito",
                categoria: 'exito'
            }
            dispatch({
                type: VARIABLE_OK,
                payload: alerta
            })

        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }

            dispatch({
                type: VARIABLE_ERROR,
                payload: alerta
            })
        }
    }
    // Selecciona el variable que el usuario dio click
    const variableActual = variableId => {
        dispatch({
            type: VARIABLE_ACTUAL,
            payload: variableId
        })
    }

    // Elimina un variable
    const eliminarVariable = async variableId => {
        try {
            await clienteAxios.delete(`/variable-dispositivos/${variableId}`);
            dispatch({
                type: ELIMINAR_VARIABLE,
                payload: variableId
            })
            const alerta = {
                msg: "Eliminado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: VARIABLE_OK,
                payload: alerta
            })
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }

            dispatch({
                type: VARIABLE_ERROR,
                payload: alerta
            })
        }
    }

    const desactivarVariable = async (info) => {
        let toSave = info
        let id = info._idDispositivo

        toSave.supervisadaOld = info.supervisada
        toSave.enviaMailOld = info.enviaMail
        toSave.enviaSMSOld = info.enviaSMS
        toSave.valorComparacionOld = info.valorComparacion
        toSave.tipoComparacionOld = info.tipoComparacion

        toSave.enviaSMS = false
        toSave.enviaMail = false
        toSave.supervisada = "NO"
        toSave.valorComparacion = ""
        toSave.dispositivo = id
        toSave.procedencia = "desactivar"

        actualizarVariable(toSave)
            .then(value => {
                return value
            })
    }
    const activarVariable = async (info) => {
        let toSave = info
        let id = info._idDispositivo

        toSave.supervisada = info.supervisadaOld
        toSave.enviaMail = info.enviaMailOld
        toSave.enviaSMS = info.enviaSMSOld
        toSave.valorComparacion = info.valorComparacionOld
        toSave.tipoComparacion = info.tipoComparacionOld
        toSave.dispositivo = id

        toSave.supervisadaOld = ""
        toSave.enviaMailOld = false
        toSave.enviaSMSOld = false
        toSave.valorComparacionOld = ""
        toSave.tipoComparacionOld = ""
        toSave.procedencia = "activar"

        actualizarVariable(toSave)
            .then(value => {
                return value
            })
    }

    const eliminarAlerta = async (info) => {
        let toSave = info
        let id = info._idDispositivo

        toSave.supervisadaOld = ""
        toSave.enviaMailOld = false
        toSave.enviaSMSOld = false
        toSave.valorComparacionOld = ""
        toSave.tipoComparacionOld = ""
        toSave.enviaSMS = false
        toSave.enviaMail = false
        toSave.supervisada = "NO"
        toSave.valorComparacion = ""
        toSave.valorComparacionOld = ""
        toSave.tipoComparacionOld = ""
        toSave.dispositivo = id
        actualizarVariable(toSave)
            .then(value => {
                return value
            })
    }
    // Aactualizar variable

    const actualizarVariable = async variable => {
        try {

            const resultado = await clienteAxios.put(`/variable-dispositivos/${variable.id}`, variable);
            // Actualizo el disp en el state
            dispatch({
                type: ACTUALIZAR_VARIABLE,
                payload: resultado.variableDispositivo
            })
            if (variable.procedencia) {
                if (variable.procedencia === "desactivar") {
                    const alerta = {
                        msg: "Notificación desactivada",
                        categoria: 'warning'
                    }
                    dispatch({
                        type: VARIABLE_OK,
                        payload: alerta
                    })
                } else if (variable.procedencia === "activar") {
                    const alerta = {
                        msg: "Notificacion activada",
                        categoria: 'exito'
                    }
                    dispatch({
                        type: VARIABLE_OK,
                        payload: alerta
                    })
                }
            } else {
                const alerta = {
                    msg: "Operacion realizada con exito",
                    categoria: 'exito'
                }
                dispatch({
                    type: VARIABLE_OK,
                    payload: alerta
                })
            }
            const alerta = {
                msg: "Operacion realizada con exito",
                categoria: 'exito'
            }
            dispatch({
                type: VARIABLE_OK,
                payload: alerta
            })
            return resultado
        } catch (error) {

            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            dispatch({
                type: VARIABLE_ERROR,
                payload: alerta
            })
            return alerta
        }
    }

    // muestra un error de validacion
    const errorVariable = (msj, categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }
        dispatch({
            type: VARIABLE_ERROR,
            payload: alerta
        })
    }
    const okVariable = (msj, categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }
        dispatch({
            type: VARIABLE_OK,
            payload: alerta
        })
    }

    // Obtengo un variable por id
    const obtenerVariable = async (variableId) => {

        try {
            const resultado = await clienteAxios.get(`/variable/${variableId}`);
            dispatch({
                type: OBTENER_VARIABLE,
                payload: resultado.data.variable
            })
            return resultado.data.variable;

        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            dispatch({
                type: VARIABLE_ERROR,
                payload: alerta
            })
        }
    }

    const clearOkVariable = () => {
        dispatch({
            type: VARIABLE_OK,
            payload: null,
        });
    };
    const clearErrorVariable = () => {
        dispatch({
            type: VARIABLE_ERROR,
            payload: null,
        });
    };
    return (
        <VariableContext.Provider
            value={{
                variables: state.variables,
                variable: state.variable,
                dipositivo: state.dipositivo,
                loading: state.loading,
                errorformulario: state.errorformulario,
                mensaje: state.mensaje,
                obtenerVariables,
                obtenerVariable,
                agregarVariable,
                variableActual,
                eliminarVariable,
                actualizarVariable,
                errorVariable,
                okVariable,
                clearErrorVariable,
                clearOkVariable,
                activarVariable,
                desactivarVariable,
                eliminarAlerta,
                obtenerVariablesTabla
            }}
        >{props.children}

        </VariableContext.Provider>
    )
}
export default VariableState;
